import setAdditionalMetaOptions from '@/js/common/Domain/Service/setAdditionalMetaOptions';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    url: `${window.appConfig.apiGatewayUrl}/frontend/tours`,
    data: {
        dc: window.appConfig.showcaseDC,
        ...tourCriteriaForTourRequest,
        ...setAdditionalMetaOptions(),
        allToursPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'routes', 'legs', 'firstPaymentDefinitions', 'airlines', 'offerPromo'],
    },
}, callback);